export const CATEGORY_TYPES = [
  {
    id: 1,
    name: 'Templates',
    order: 10,
  },
  {
    id: 2,
    name: 'Presets',
    order: 20,
  },
  {
    id: 3,
    name: 'Audio',
    order: 30,
  },
  {
    id: 4,
    name: 'Video',
    order: 40,
  },
  {
    id: 5,
    name: 'Images',
    order: 50,
  },
];
